import styled from "styled-components";
import * as FilterDropdownStyles from "./FilterDropdownStyles";

export const Wrapper = styled.div`
    text-align: start;
    ${FilterDropdownStyles.Wrapper} {
        background: none;
    }
`;
